import { useEffect } from 'react';

const useOnClickOutside = (ref: any, handler: any): any => useEffect(
    () => {
        const listener = (event: any): void => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }

            handler(event);
        };

        document.addEventListener('mousedown', listener, { passive: true });
        document.addEventListener('touchstart', listener, { passive: true });

        return (): void => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    },
    [ref, handler]
);

export default useOnClickOutside;
